import { ColumnMeta, RowData } from '@tanstack/react-table';
import { INotificationsSettingsRow } from '../types';

export const NOTIFICATIONS_TABLE_CONFIG: Record<
  string,
  ColumnMeta<INotificationsSettingsRow, RowData>
> = {
  eventDescription: {
    style: {
      flexGrow: 1,
      flexBasis: '120px',
      minWidth: '120px',
    },
  },
  slack: {
    style: {
      flexBasis: '32px',
      minWidth: '32px',
      textAlign: 'center',
    },
  },
  email: {
    style: {
      flexBasis: '32px',
      minWidth: '32px',
      textAlign: 'center',
    },
  },
};
